// components/BusinessCard.js
import React from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import '../assets/BusinessCard.scss';
import { slugify } from '../utils/utils';
import { useDispatch } from 'react-redux';
import { setSelectedEtablissementId } from '../store/slices/etablissementSlice';

const BusinessCard = ({ name, isHovered, activity, address, id }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const handleClick = () => {
    dispatch(setSelectedEtablissementId(id));
    navigate(`/etablissement-non-inscrit/${slugify(name)}`, { state: { placeId: id } })
  };
  return (
    <div className={`business-card ${isHovered ? "hovered-google" : ""}`}>
        
        <h5 className="grey500 mb-0">{name}</h5>
        <p className="mb-0 mt-4 body grey66">{activity}</p>
        <div className="business-card__info">
        <p className="legend grey66 mb-0 mt-8">{address}</p>
        <span
        className="link-blue pointer text-end"
        onClick={handleClick}
      >
        Voir le professionnel
      </span>
      </div>
      
    </div>
  );
};

export default BusinessCard;